<template>
  <ga-image-responsive
    :image="source.image"
    :alt="source.meta.alt"
    :title="source.meta.title"
    :class="b()"
    :class-name="b('img')"
    @load="($event) => $emit('image-load', $event)"
  />
</template>

<script src="./media-item.scripts.js" />

<style module src="./media-item.styles.scss" lang="scss" />
